// src/lib/partner/partnerSupport.js

import { supabase } from "../../supabaseClient";

export async function fetchMyPartnerSupportRequests(
  status = null
) {
  const {
    data,
    error,
  } = await supabase.rpc(
    "get_my_partner_support_requests",
    {
      p_status:
        status || null,
    }
  );

  if (error) {
    throw error;
  }

  return Array.isArray(data)
    ? data
    : [];
}

export async function updateMyPartnerSupportRequestStatus(
  requestId,
  status
) {
  const cleanRequestId =
    String(
      requestId || ""
    ).trim();

  const cleanStatus =
    String(
      status || ""
    )
      .trim()
      .toLowerCase();

  if (!cleanRequestId) {
    throw new Error(
      "A support request is required."
    );
  }

  if (
    ![
      "acknowledged",
      "resolved",
      "closed",
    ].includes(
      cleanStatus
    )
  ) {
    throw new Error(
      "Invalid support request status."
    );
  }

  const {
    data,
    error,
  } = await supabase.rpc(
    "update_my_partner_support_request_status",
    {
      p_request_id:
        cleanRequestId,

      p_status:
        cleanStatus,
    }
  );

  if (error) {
    throw error;
  }

  if (
    Array.isArray(data)
  ) {
    return data[0] || null;
  }

  return data || null;
}